export enum DocumentsDownloadEndpoints {
    // must send systemCode as query param
    GetPgaList = "insureds/:userIdentity/insurances/all/policies/:policyId/files",
    // must send contractor-id as query param
    GetEpsList = "ms-ux-mep-gestion-de-documentos-cliente-pga/servicio-al-cliente/v1/api/insureds/me/insurances/eps/plans/:plan-number}/files",
    // must send systemCode as query param
    GetHealthList = "ms-ux-mep-gestion-de-documentos-cliente-pga/servicio-al-cliente/v1/api/insureds/me/insurances/salud/policies/:policyId/files",
    GetPgaDocumentDetail = "insureds/:userIdentity/insurances/all/policies/:policyId/files/:fileId",
    // must send system-code, file-id and policy-number as query params
    GetHealthDocumentDetail = "ms-ux-mep-gestion-de-documentos-cliente-pga/servicio-al-cliente/v1/api/insureds/me/insurances/salud/policies/:policyId/files/:fileId",
    GetEpsDocumentDetail = "ms-ux-mep-gestion-de-documentos-cliente-pga/servicio-al-cliente/v1/api/insureds/me/insurances/eps/plans/:planNumber/files",
    GetSoatDocumentDetail = "insureds/:userIdentity/insurances/all/certificates/download",
    GetPgaCertificateDocumentDetail = "insureds/:userIdentity/insurances/all/certificates/download",
}
